import { render, staticRenderFns } from "./StatisticsRow.vue?vue&type=template&id=04330d3c&"
import script from "./StatisticsRow.vue?vue&type=script&lang=js&"
export * from "./StatisticsRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Data\\TeamCity\\buildAgent\\work\\6dffdb6616650f37\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04330d3c')) {
      api.createRecord('04330d3c', component.options)
    } else {
      api.reload('04330d3c', component.options)
    }
    module.hot.accept("./StatisticsRow.vue?vue&type=template&id=04330d3c&", function () {
      api.rerender('04330d3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/CanvasArea/Bricks/TouchpointOverview/Statistics/Page/StatisticsRow.vue"
export default component.exports